
/**
 * @author Sai Prasad
 * @class SpecificationForm
 */

import React, { useState, useEffect } from 'react';
import Form from '../Form';
import Button from '../Button';
import Row from '../Row';
import Col from '../Col';
import Input from '../Input';
import TextEditor from '../Editor/Editor';
import Toast from '../Toast';
import { useSelector, useDispatch } from 'react-redux';
import { convertHTMLToString } from '../../helpers/validationHelper';
import { selectValidation } from '../../store/selectors/Validation';
import { clearValidation } from '../../store/actions/validation';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import Loader from '../Loader';
import { stopFormLoading } from '../../store/actions/loader';

const SpecificationForm = ({
    breadcrumb,
    onClose,
    itemId,
    onSaveSpecification,
    specification
}) => {
    const dispatch = useDispatch();
    const [title, setTitle] = useState(specification?.title || "");
    const [description, setDescription] = useState(specification?.description || "");
    const [convertedDescription, setConvertedDescription] = useState('');
    const [type, setType] = useState('');
    const user = useSelector(state => state.auth?.user || {});
    const validation = useSelector(state => selectValidation(state));
    const loader = useSelector(state => selectFormLoader(state));
    
    useEffect(() => {
        dispatch(stopFormLoading());
        dispatch(clearValidation());
        if(specification && specification.id) {
          onSetDescription(specification.description);
        }
    },[]);

    useEffect(() => {
        if(validation.status === true) {
            if(validation.message === 'Specification Saved' && type === 'SaveAndClose') {
              onClose();
              dispatch(clearValidation());
            } else if(validation.message === 'Specification Saved' && type === 'SaveAndAdd') {
              dispatch(clearValidation());
              clearState();
            }
        }
    },[validation]);

    const clearState = () => {
        setType('');
        setTitle('');
        setDescription('');
        setConvertedDescription('');
    }
    const onSetTitle = (value) => {
        setTitle(value);
    }
    const onSetDescription = (value) => {
        let convertedDescription = convertHTMLToString(value);
        setDescription(value);
        setConvertedDescription(convertedDescription);
    }
    const saveSpecification = (type) => {
        setType(type);
        const params = {
            title: title,
            description: description,
            catalogId: itemId,
            userId: user.id
        }
        if(specification && specification.id) {
          onSaveSpecification({...params, id: specification.id});
        } else {
          onSaveSpecification(params);
        }
    }
    return (
        <Form
        headline={(specification?.id ? "Edit" : "Add") +" a Specification"}
        onClose={onClose}
        actions={(
          <>
            {loader && <Loader center={true} />}
            {specification && !specification.id &&
            <Button
                color="semantic"
                size="small"
                label="Save and Add Another"
                onClick={() => saveSpecification('SaveAndAdd')}
                disabled={!title?.trim() || !convertedDescription?.trim()}
            /> }
            <Button
              color="teal"
              size="small"
              label="Save Specification"
              onClick={() => saveSpecification('SaveAndClose')}
              disabled={!title?.trim() || !convertedDescription?.trim()}
            />
          </>
        )}
        component={(
            <>
            <Row mdCenter>
            <Col xs="12" md="6">
            {breadcrumb && (
                  <>
                    <Toast
                      message={
                        <>
                          You are adding a specification to <strong>{breadcrumb}</strong>
                          .
                        </>
                      }
                    />
                    <br />
                    <br />
                  </>
                )}
                 <Input
                  value={title}
                  onChange={(e) => onSetTitle(e.target.value)}
                  label="Title"
                  required
                  placeholder="Title"
                  block
                />
                <div className="input">
                  <div className="input__require">
                    <label className="input__label">Description</label>
                    <div className="input__required" />
                  </div>
                  <div class style={{borderBottom: '0.1rem solid rgba(83, 83, 83, 0.25)'}} className="input__control">
                <TextEditor
                    editorState={description}
                    onEditorStateChange={onSetDescription}
                />
                </div>
                </div>
            </Col>
            </Row>
            </>
        )}
        />
    )
}
export default SpecificationForm;